import { IMAGE_PATHS } from 'constants/imagePaths';
import { Image, Stack } from 'react-bootstrap';
import useTranslate from 'hooks/useTranslate';

const AuthLeftPanel = () => {
	const { translate } = useTranslate();
	return (
		<>
			<Image src={IMAGE_PATHS.authBG} alt="logo" className="left-content-bg-img" loading="lazy" />

			<Stack className="welcome-text justify-content-end h-100 gap-1 gap-md-3">
				<Image
					src={IMAGE_PATHS.Arrow}
					alt="arrow"
					className="arrow w-auto ms-auto"
					loading="lazy"
				/>
				<h2 className="mb-0 position-relative">{translate('Common.welcomeTo')}</h2>
				<Image
					src={IMAGE_PATHS.StassifyLogo}
					alt="logo"
					className="logo w-auto me-auto"
					loading="lazy"
				/>
				<p className="mb-0">{translate('Auth.authLeftPanelDescription')}</p>
			</Stack>
		</>
	);
};

export default AuthLeftPanel;
